module.exports = __webpack_public_path__ + "media/errorLight.2e337cc3.svg";